export default {
  title: "Stagnant Unsubmitted work",
  content:
    "You have unsubmitted work that was drafted <b class='text-info'>{days} days</b> ago! Consider resuming or discarding it through <b class='text-info'>To-Do</b>.",
}
